/* ═══════════════════════════════════════════════════════
   MG Pappas — Aegean Terroir Theme JavaScript
   Handles: animations, testimonial carousel, mobile menu,
   email popup, product scroll, header scroll state
═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  // ── Intersection Observer for fade-up animations ──
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.fade-up').forEach(function(el) {
    observer.observe(el);
  });

  // ── Header scroll state ──
  var header = document.querySelector('.site-header');
  if (header) {
    var isHomePage = window.location.pathname === '/' || window.location.pathname === '';
    function updateHeader() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
        header.classList.remove('transparent');
      } else {
        header.classList.remove('scrolled');
        if (isHomePage) {
          header.classList.add('transparent');
        }
      }
    }
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  // ── Mobile menu toggle ──
  var mobileToggle = document.querySelector('.mobile-toggle');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
      if (mobileMenu.classList.contains('open')) {
        mobileToggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
      } else {
        mobileToggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>';
      }
    });

    // Close mobile menu when a link is clicked
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
        mobileToggle.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>';
      });
    });
  }

  // ── Testimonial Carousel ──
  var testimonials = document.querySelectorAll('.testimonial-slide');
  var dots = document.querySelectorAll('.testimonial-dot');
  var currentTestimonial = 0;

  function showTestimonial(index) {
    testimonials.forEach(function(t, i) {
      t.style.display = i === index ? 'block' : 'none';
    });
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === index);
    });
    currentTestimonial = index;
  }

  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      showTestimonial(i);
    });
  });

  // Auto-advance testimonials every 6 seconds
  if (testimonials.length > 0) {
    showTestimonial(0);
    setInterval(function() {
      var next = (currentTestimonial + 1) % testimonials.length;
      showTestimonial(next);
    }, 6000);
  }

  // ── Touch Swipe for Testimonials ──
  var testimonialContainer = document.querySelector('.testimonial-carousel');
  if (testimonialContainer && testimonials.length > 1) {
    var touchStartX = 0;
    var touchEndX = 0;
    testimonialContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    testimonialContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          showTestimonial((currentTestimonial + 1) % testimonials.length);
        } else {
          showTestimonial((currentTestimonial - 1 + testimonials.length) % testimonials.length);
        }
      }
    }, { passive: true });
  }

  // ── Product Scroll Buttons ──
  var scrollContainer = document.querySelector('.products-scroll');
  var scrollLeftBtn = document.querySelector('.scroll-left');
  var scrollRightBtn = document.querySelector('.scroll-right');

  if (scrollContainer && scrollLeftBtn && scrollRightBtn) {
    scrollLeftBtn.addEventListener('click', function() {
      scrollContainer.scrollBy({ left: -300, behavior: 'smooth' });
    });
    scrollRightBtn.addEventListener('click', function() {
      scrollContainer.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }

  // ── Email Popup ──
  var popupOverlay = document.querySelector('.email-popup-overlay');
  var popupClose = document.querySelector('.email-popup-close');
  var popupDismissed = sessionStorage.getItem('mgp_popup_dismissed');

  if (popupOverlay && !popupDismissed) {
    setTimeout(function() {
      popupOverlay.style.display = 'flex';
    }, 5000);
  }

  if (popupClose) {
    popupClose.addEventListener('click', function() {
      popupOverlay.style.display = 'none';
      sessionStorage.setItem('mgp_popup_dismissed', 'true');
    });
  }

  // Close popup on overlay click
  if (popupOverlay) {
    popupOverlay.addEventListener('click', function(e) {
      if (e.target === popupOverlay) {
        popupOverlay.style.display = 'none';
        sessionStorage.setItem('mgp_popup_dismissed', 'true');
      }
    });
  }

  // Email popup form submission
  var popupForm = document.querySelector('.email-popup-form');
  if (popupForm) {
    popupForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var emailInput = popupForm.querySelector('input[type="email"]');
      if (emailInput && emailInput.value) {
        // Show success state
        popupForm.innerHTML = '<div style="text-align:center;padding:1rem 0;"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#3D5A2B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin:0 auto 1rem;"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg><p style="font-family:var(--font-display);font-size:1.25rem;font-weight:700;color:var(--charcoal);margin-bottom:0.5rem;">Welcome to the Family!</p><p style="font-family:var(--font-body);font-size:0.875rem;color:rgba(44,42,37,0.6);">Use code <strong>GROVE10</strong> at checkout for 10% off.</p></div>';
        sessionStorage.setItem('mgp_popup_dismissed', 'true');
        setTimeout(function() {
          popupOverlay.style.display = 'none';
        }, 4000);
      }
    });
  }

});

// ── Quantity Selectors (Product Detail & Cart) ──
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.qty-btn');
  if (!btn) return;
  var input = btn.parentElement.querySelector('.qty-input');
  if (!input) return;
  var val = parseInt(input.value) || 1;
  if (btn.classList.contains('qty-minus')) {
    input.value = Math.max(1, val - 1);
  } else if (btn.classList.contains('qty-plus')) {
    input.value = Math.min(10, val + 1);
  }
});

// ── Product Thumbnail Switcher ──
document.addEventListener('click', function(e) {
  var thumb = e.target.closest('.product-thumb');
  if (!thumb) return;
  var url = thumb.getAttribute('data-image-url');
  if (!url) return;
  var mainImg = document.querySelector('.product-image-wrapper img');
  if (mainImg) mainImg.src = url;
  document.querySelectorAll('.product-thumb').forEach(function(t) {
    t.classList.remove('active');
  });
  thumb.classList.add('active');
});
